import getRequestParams from '../utilities/get-request-params'

function TabbedContent() {
	this.elements = {}
	this.getChildIndex = (button) => {
		var child = button.parentElement
		var parent = child.parentElement

		return Array.prototype.indexOf.call(parent.children, child)
	}

	this.hidePanel = function (button) {
		var parent = button.closest('.js-tabbed-content')

		if (parent) {
			var activeButton = parent.querySelector('button.is-active')
			if (activeButton) {
				var activePanelId = activeButton.getAttribute('aria-controls')
				var activePanel = document.querySelector('#' + activePanelId)

				activePanel.classList.remove('is-active')
				activeButton.classList.remove('is-active')
				activeButton.setAttribute('aria-expanded', false)
			}
		}
	}

	this.showPanel = function (event) {
		if (!event.target.nodeName === 'BUTTON') return

		const button = event.target
		this.hidePanel(button)

		var panelId = button.getAttribute('aria-controls')
		var panel = document.querySelector('#' + panelId)

		button.classList.add('is-active')
		button.setAttribute('aria-expanded', true)
		panel.classList.add('is-active')

		// create and dispatch the event
		window.dispatchEvent(
			new CustomEvent('ExpandTabAccordion', {
				detail: {
					itemIndex: this.getChildIndex(button),
				},
			})
		)
	}

	this.cacheDom = function (tabbedContentRoot) {
		this.elements.tabs = tabbedContentRoot.querySelectorAll('.js-tab')
	}

	this.bind = function () {
		if (this.elements.tabs) {
			for (var i = 0; i < this.elements.tabs.length; i++) {
				this.elements.tabs[i].addEventListener('click', this.showPanel.bind(this), true)
			}
		}
	}

	this.destroy = function () {
		if (this.elements.tabs) {
			for (var i = 0; i < this.elements.tabs.length; i++) {
				this.elements.tabs[i].removeEventListener('click', this.showPanel.bind(this), true)
			}
		}
	}

	this.activateRequestedTab = () => {
		const params = getRequestParams()

		if (params.tab) {
			const tab = document.querySelector(`[id="${params.tab}"]`)

			if (tab) tab.click()
		}
	}

	this.init = function (tabbedContentRoot, callback) {
		this.cacheDom(tabbedContentRoot)
		this.bind()

		if (callback) callback()

		this.activateRequestedTab()
	}
}

export default TabbedContent
